import rootSaga from "./rootSaga";
import createSagaMiddleware from "redux-saga";
import rootReducer from "./combineReducers";
import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import journeyMiddleware from "./middleware/journeyMiddleware";

const sagaMiddleware = createSagaMiddleware();

const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(sagaMiddleware, journeyMiddleware))
);

sagaMiddleware.run(rootSaga);

export default store;
